<div class="thumbnail-selected-indicator"></div>
